export enum MqttEventType {
  VisitVideoEnded = 'visitvideoended',
  VisitVideoStarted = 'visitvideostarted',
}

interface VisitVideoEndedPayload {
  eventType: MqttEventType.VisitVideoEnded;
  sessionId: string | null;
  visitId: string;
  visitVideoCallId: string;
}

interface VideoVisitStartedPayload {
  eventType: MqttEventType.VisitVideoStarted;
  sessionId: string | null;
  visitId: string;
  visitVideoCallId: string;
}

export type MqttEventPayload = {
  [MqttEventType.VisitVideoEnded]: VisitVideoEndedPayload;
  [MqttEventType.VisitVideoStarted]: VideoVisitStartedPayload;
};
